import MainLayout from "@/components/layout/MainLayout";
import { useAuth } from "@/contexts/UnifiedAuthContext";
import { EmailSection } from "@/components/profile/EmailSection";
import { TelegramSection } from "@/components/profile/TelegramSection";
import { NotificationSection } from "@/components/profile/NotificationSection";
import { AccountIdSection } from "@/components/profile/AccountIdSection";
import { ThemeSelector } from "@/components/theme/ThemeSelector";
import { ApiSettings } from "@/components/profile/ApiSettings";
import { useTranslation } from "react-i18next";

const Profile = () => {
  const { user } = useAuth();
  const { t } = useTranslation();

  return (
    <MainLayout>
      <div className="container-page">
        <h1 className="text-2xl font-bold mb-6">
          <div className="flex flex-col">
            <span>{t('profile.title')}</span>
          </div>
        </h1>

        <div className="max-w-3xl mx-auto">
          <div className="space-y-10">
            {/* Настройки внешнего вида - показываем только не в Telegram */}
            <ThemeSelector />

            <NotificationSection />
            <EmailSection />
            <TelegramSection />

            <ApiSettings userId={user?.id} />

            <AccountIdSection />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default Profile;
